import { AnalyticsBrowser } from '@nwwp/segment-analytics'
import { objectKeysToSnakeCase } from '@nwwp/utils'
import { ExposureData } from './eventLogging'

interface BucketedEventParams {
  attributes: Record<string, string>
  exposureData: ExposureData[]
}

export const logABSmartlyBucketingDecision = async (params: BucketedEventParams, analytics: AnalyticsBrowser) => {
  if (!analytics?.track || !analytics?.user) return

  const user = await analytics.user()
  const anonymousId = user.anonymousId()

  for (const { experimentKey, variationKey, unitType } of params.exposureData) {
    void analytics.track('Absmartly Experiment Bucketing Decision', {
      bucketing_id: anonymousId,
      bucketing_id_type: unitType,
      user_agent: navigator.userAgent,
      experiment_key: experimentKey,
      user_attributes: objectKeysToSnakeCase(params.attributes),
      variation_key: variationKey,
      additional_attributes: {
        decision_location: 'client',
      },
    })
  }
}
